(function(){
"use strict";

var PROJECT_URL="https://ycentdpkspjdrzijrbsl.supabase.co";
var API_KEY="sb_publishable_TgKotXn3vvPpdnad_wXc9g_X1DY7arT";
var STORAGE_KEY="sb-ycentdpkspjdrzijrbsl-auth-token";
var current=null;
var panelBusy=false;

function authToken(){
  try{
    var raw=localStorage.getItem(STORAGE_KEY);
    if(!raw)return null;
    var v=JSON.parse(raw);
    return v&&v.access_token?v.access_token:null;
  }catch(e){return null;}
}
function esc(v){
  return String(v==null?"":v).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#039;");
}
function money(v){
  try{return new Intl.NumberFormat("sv-SE",{style:"currency",currency:"SEK",maximumFractionDigits:0}).format(Number(v||0));}
  catch(e){return Math.round(Number(v||0))+" kr";}
}
function parseMoneyInput(v){
  var raw=String(v==null?"":v).trim().replace(/\s/g,"").replace(/kr$/i,"").replace(",",".");
  var n=Number(raw);
  return isFinite(n)?Math.round(n*100)/100:NaN;
}
function showPaymentError(msg){
  var host=document.getElementById("kp-po-payment-detail")||document.querySelector(".kp-po-body");
  if(!host)return;
  var old=document.getElementById("kp-po-payment-error");if(old)old.remove();
  var box=document.createElement("div");
  box.id="kp-po-payment-error";
  box.className="kp-po-order-saved";
  box.style.background="#FFF1F0";
  box.style.color="#9B2C23";
  box.style.border="1px solid #F3C3BE";
  box.style.marginTop=".75rem";
  box.textContent=msg||"Något gick fel.";
  host.prepend(box);
}
async function rpc(name,body){
  var t=authToken();
  if(!t)throw new Error("Du behöver vara inloggad.");
  var r=await fetch(PROJECT_URL+"/rest/v1/rpc/"+name,{
    method:"POST",
    headers:{"apikey":API_KEY,"Authorization":"Bearer "+t,"Content-Type":"application/json"},
    body:JSON.stringify(body||{})
  });
  if(!r.ok){
    var msg="";
    try{var j=await r.json();msg=j.message||j.error||"";}catch(e){}
    throw new Error(msg||"Något gick fel.");
  }
  return await r.json();
}
function route(){return location.hash.split("?")[0];}
function root(){
  var r=document.getElementById("kp-personal-order-root");
  if(!r){r=document.createElement("div");r.id="kp-personal-order-root";document.body.appendChild(r);}
  return r;
}
function close(){
  root().innerHTML="";
  current=null;
}
function overlay(html){
  root().innerHTML='<div class="kp-po-overlay" role="presentation"><div class="kp-po-dialog" role="dialog" aria-modal="true">'+html+'</div></div>';
}
function head(title,sub,locked){
  return '<div class="kp-po-head"><div><h2>'+esc(title)+'</h2><p>'+esc(sub||"")+'</p></div>'+
    '<button type="button" class="kp-po-close" id="kp-po-close" aria-label="Stäng">×</button></div>';
}
function bindClose(){
  var b=document.getElementById("kp-po-close");
  if(b)b.addEventListener("click",function(){
    if(current&&current.order&&current.order.preview_mode){close();return;}
    if(current&&current.order&&current.order.payment_reported_at==null){
      if(confirm("Ordern är sparad som obetald. Vill du stänga och registrera betalningen senare?"))close();
    }else close();
  });
}
async function loadPortal(){
  return await rpc("get_portal_context_v27",{p_group_id:null});
}
function activeProducts(portal){
  return (portal.products||[]).filter(function(p){return p&&p.active!==false;});
}
function totalFor(products,qty){
  return products.reduce(function(sum,p){return sum+Number(p.retail_price||0)*Number(qty[String(p.id)]||0);},0);
}
function cartItems(products,qty){
  return products.filter(function(p){return Number(qty[String(p.id)]||0)>0;}).map(function(p){
    return {product_id:p.id,quantity:Number(qty[String(p.id)]||0)};
  });
}
function orderStepHtml(portal,qty){
  var products=activeProducts(portal);
  var rows=products.map(function(p){
    return '<div class="kp-po-product"><div><div class="kp-po-product-name">'+esc((p.emoji||"📦")+" "+p.name)+'</div><div class="kp-po-product-price">'+esc(money(p.retail_price))+' / st</div></div>'+
      '<div class="kp-po-qty"><button type="button" data-po-step="-1" data-po-id="'+esc(p.id)+'">−</button><strong data-po-count="'+esc(p.id)+'">'+Number(qty[String(p.id)]||0)+'</strong><button type="button" data-po-step="1" data-po-id="'+esc(p.id)+'">+</button></div></div>';
  }).join("");
  return head("Personlig order","För dörrförsäljning eller beställningar från pappersbladet.")+
    '<div class="kp-po-body"><div class="kp-po-step">'+
      '<div><b>1. Välj produkter</b><div class="kp-po-products mt-2">'+rows+'</div></div>'+
      '<div><b>2. Kunduppgifter</b><div class="kp-po-fields mt-2">'+
        '<div class="kp-po-field"><label for="kp-po-name">Kundens namn</label><input id="kp-po-name" autocomplete="name" placeholder="För- och efternamn"></div>'+
        '<div class="kp-po-field"><label for="kp-po-phone">Telefon</label><input id="kp-po-phone" inputmode="tel" autocomplete="tel" placeholder="07..."></div>'+
        '<div class="kp-po-field"><label for="kp-po-email">E-post <span style="font-weight:500;color:var(--ink-3)">(valfritt)</span></label><input id="kp-po-email" type="email" autocomplete="email" placeholder="kund@example.se"></div>'+
        '<div class="kp-po-field"><label for="kp-po-address">Adress <span style="font-weight:500;color:var(--ink-3)">(valfritt)</span></label><input id="kp-po-address" autocomplete="street-address" placeholder="Gatuadress"></div>'+
        '<div class="kp-po-field"><label for="kp-po-postal">Postnummer</label><input id="kp-po-postal" inputmode="numeric" autocomplete="postal-code" placeholder="123 45"></div>'+
        '<div class="kp-po-field"><label for="kp-po-city">Ort</label><input id="kp-po-city" autocomplete="address-level2" placeholder="Stockholm"></div>'+
        '<div class="kp-po-field" style="grid-column:1/-1"><label for="kp-po-notes">Leveransnotering <span style="font-weight:500;color:var(--ink-3)">(valfritt)</span></label><input id="kp-po-notes" placeholder="Exempel: ring innan utlämning"></div>'+
      '</div></div>'+
      '<div class="kp-po-summary"><b>Produkter totalt</b><strong id="kp-po-total">'+money(totalFor(products,qty))+'</strong></div>'+
      '<p class="kp-po-note">Namn och telefon behövs för ordern. E-post och adress är valfria och ska bara fyllas i om kunden vill lämna dem eller gruppen faktiskt behöver dem för kontakt/utlämning. Det innebär inte hemleverans från Kampansera.</p>'+
      '<div class="kp-po-actions"><button type="button" class="btn btn-primary" id="kp-po-create">Fortsätt till betalning</button></div>'+
    '</div></div>';
}
function bindOrderStep(portal,qty){
  bindClose();
  var products=activeProducts(portal);
  document.querySelectorAll("[data-po-step]").forEach(function(b){
    b.addEventListener("click",function(){
      var id=String(b.dataset.poId),step=Number(b.dataset.poStep||0);
      qty[id]=Math.max(0,Math.min(20,Number(qty[id]||0)+step));
      var count=document.querySelector('[data-po-count="'+CSS.escape(id)+'"]');
      if(count)count.textContent=qty[id];
      var total=document.getElementById("kp-po-total");if(total)total.textContent=money(totalFor(products,qty));
    });
  });
  var create=document.getElementById("kp-po-create");
  if(create)create.addEventListener("click",async function(){
    var name=(document.getElementById("kp-po-name").value||"").trim();
    var phone=(document.getElementById("kp-po-phone").value||"").trim();
    var email=(document.getElementById("kp-po-email").value||"").trim();
    var address=(document.getElementById("kp-po-address").value||"").trim();
    var postal=(document.getElementById("kp-po-postal").value||"").trim();
    var city=(document.getElementById("kp-po-city").value||"").trim();
    var notes=(document.getElementById("kp-po-notes").value||"").trim();
    var items=cartItems(products,qty);
    if(!items.length){alert("Välj minst en produkt.");return;}
    if(name.length<2){alert("Fyll i kundens namn.");return;}
    if(phone.replace(/\D/g,"").length<7){alert("Fyll i ett giltigt telefonnummer.");return;}
    if(email&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){alert("Kontrollera e-postadressen.");return;}
    if(address||postal||city){
      if(!address||!postal||!city){alert("Om adress används behöver adress, postnummer och ort fyllas i.");return;}
      if(!/^\d{3}\s?\d{2}$/.test(postal)){alert("Kontrollera postnumret.");return;}
    }
    create.disabled=true;create.textContent="Skapar order…";
    try{
      var out=await rpc("create_personal_order_v2",{
        p_campaign_id:portal.campaign.id,
        p_customer_name:name,
        p_customer_phone:phone,
        p_items:items,
        p_customer_email:email||null,
        p_customer_address1:address||null,
        p_customer_postal_code:postal||null,
        p_customer_city:city||null,
        p_delivery_notes:notes||null
      });
      current={portal:portal,order:out,customer:{name:name,phone:phone,email:email,address:address,postal:postal,city:city},qty:qty};
      showPayment(out);
    }catch(e){alert(e.message||"Kunde inte skapa ordern.");create.disabled=false;create.textContent="Fortsätt till betalning";}
  });
}
function paymentMethodButtons(order){
  return '<div class="kp-po-methods">'+
    '<button type="button" class="kp-po-method" data-method="swish"'+(order.swish_enabled?'':' disabled')+'><b>📱 Swish</b><span>'+(order.swish_enabled?'Visa QR, exakt summa och ordernummer':'Inte aktiverat av gruppansvarig')+'</span></button>'+
    '<button type="button" class="kp-po-method" data-method="cash"'+(order.cash_enabled?'':' disabled')+'><b>💵 Kontant</b><span>'+(order.cash_enabled?'Räkna växel och extra stöd automatiskt':'Inte aktiverat av gruppansvarig')+'</span></button>'+
  '</div>';
}
function showPayment(order){
  var hasAny=order.swish_enabled||order.cash_enabled;
  overlay(head("Betalning","Order "+String(order.display_number||"")+" är skapad.")+
    '<div class="kp-po-body"><div class="kp-po-step">'+
      (order.preview_mode
        ? '<div class="kp-po-order-saved"><b>Testläge.</b> Kampanjen är inte öppen för riktig försäljning just nu. Du kan testa hela betalningsflödet, men denna testorder sparas inte och påverkar ingen statistik eller avräkning.</div>'
        : '<div class="kp-po-order-saved"><b>Ordern är sparad.</b> Produkter: '+esc(money(order.total_retail))+'. Välj hur kunden betalar. Om du stänger nu ligger ordern kvar som obetald.</div>')+
      (hasAny?paymentMethodButtons(order):'<div class="kp-po-order-saved">Gruppansvarig måste först aktivera Swish eller kontant under Betalningar.</div>')+
      '<div id="kp-po-payment-detail"></div>'+
    '</div></div>');
  bindClose();
  document.querySelectorAll(".kp-po-method:not(:disabled)").forEach(function(b){
    b.addEventListener("click",function(){
      document.querySelectorAll(".kp-po-method").forEach(function(x){x.classList.remove("active");});
      b.classList.add("active");
      renderPaymentDetail(b.dataset.method,order);
    });
  });
  if(order.swish_enabled&&!order.cash_enabled)renderPaymentDetail("swish",order);
  if(order.cash_enabled&&!order.swish_enabled)renderPaymentDetail("cash",order);
}
function renderPaymentDetail(method,order){
  var host=document.getElementById("kp-po-payment-detail");if(!host)return;
  if(method==="swish"){
    host.innerHTML='<div class="kp-po-paybox"><div class="kp-po-swish">'+
      (order.swish_qr_url?'<img src="'+esc(order.swish_qr_url)+'" alt="Swish QR-kod">':'')+
      '<div><div class="kp-po-pay-amount">'+esc(money(order.total_retail))+'</div>'+
      '<div class="kp-po-pay-meta">Swish: <b>'+esc(order.swish_number||"")+'</b><br>Mottagare: '+esc(order.swish_recipient_name||"gruppen")+'</div>'+
      '<span class="kp-po-reference">Meddelande: '+esc(order.display_number||"")+'</span>'+
      '<p class="kp-po-note mt-2">Be kunden swisha exakt summan och gärna skriva ordernumret som meddelande. Registrera först när du har sett kundens Swish-bekräftelse. Kampansera verifierar inte banktransaktionen automatiskt.</p></div></div>'+
      '<div class="kp-po-actions mt-2"><button type="button" class="btn btn-primary" id="kp-po-report-swish">Kunden har swishat</button></div></div>';
    var b=document.getElementById("kp-po-report-swish");
    if(b)b.addEventListener("click",function(){reportPayment("swish",order,null,false,b);});
  }else{
    host.innerHTML='<div class="kp-po-paybox">'+
      '<div class="kp-po-cash-guide"><b>Så funkar kontant</b><span>Ordern kostar <strong>'+esc(money(order.total_retail))+'</strong>. Skriv hur mycket kunden faktiskt gav – växel eller extra stöd räknas ut direkt.</span></div>'+
      '<div class="kp-po-cash-grid">'+
        '<div class="kp-po-field"><label for="kp-po-cash">Kunden gav</label><input id="kp-po-cash" inputmode="decimal" value="'+esc(String(Number(order.total_retail||0)))+'"><div class="kp-po-input-hint">Exempel: kostar ordern 597 kr och kunden ger 700 kr skriver du 700.</div></div>'+
        '<div class="kp-po-change"><span id="kp-po-result-label">Resultat</span><b id="kp-po-change">0 kr</b><small id="kp-po-result-sub">Exakt betalning – ingen växel.</small></div>'+
      '</div>'+
      '<div class="kp-po-cash-explain" id="kp-po-cash-explain">Kunden betalar exakt '+esc(money(order.total_retail))+'.</div>'+
      '<label class="kp-po-support mt-2"><input id="kp-po-keep-change" type="checkbox" disabled><span id="kp-po-support-text">Om kunden ger mer än totalsumman kan du välja om mellanskillnaden ska vara <b>växel</b> eller, om kunden uttryckligen säger det, <b>Extra stöd till gruppen</b>.</span></label>'+
      '<div class="kp-po-actions mt-2"><button type="button" class="btn btn-primary" id="kp-po-report-cash">Registrera kontant betalning</button></div></div>';
    var inp=document.getElementById("kp-po-cash"),keep=document.getElementById("kp-po-keep-change"),change=document.getElementById("kp-po-change"),support=document.getElementById("kp-po-support-text"),explain=document.getElementById("kp-po-cash-explain"),resultLabel=document.getElementById("kp-po-result-label"),resultSub=document.getElementById("kp-po-result-sub");
    function update(){
      var received=parseMoneyInput(inp.value);
      var total=Math.round(Number(order.total_retail||0)*100)/100;
      var diff=isFinite(received)?Math.round((received-total)*100)/100:0;
      if(!isFinite(received)){
        keep.checked=false;keep.disabled=true;
        resultLabel.textContent="Resultat";
        change.textContent="–";
        resultSub.textContent="Skriv beloppet kunden gav.";
        explain.textContent="Skriv det faktiska kontantbeloppet så räknar Kampansera ut resten.";
        support.innerHTML='Om kunden ger mer än totalsumman kan du välja mellan <b>växel</b> och <b>Extra stöd till gruppen</b>.';
      }else if(diff>0){
        keep.disabled=false;
        if(keep.checked){
          resultLabel.textContent="Extra stöd";
          change.textContent=money(diff);
          resultSub.textContent="Ingen växel tillbaka.";
          explain.innerHTML='Kunden gav <b>'+esc(money(received))+'</b>. Ordern kostar <b>'+esc(money(total))+'</b> → <b>'+esc(money(diff))+' extra stöd till gruppen</b>.';
          support.innerHTML='Kunden har uttryckligen valt att gruppen får behålla <b>'+esc(money(diff))+'</b>. Detta hålls separat från produktförsäljningen.';
        }else{
          resultLabel.textContent="Växel tillbaka";
          change.textContent=money(diff);
          resultSub.textContent="Ge detta tillbaka till kunden.";
          explain.innerHTML='Kunden gav <b>'+esc(money(received))+'</b>. Ordern kostar <b>'+esc(money(total))+'</b> → <b>'+esc(money(diff))+' i växel</b>.';
          support.innerHTML='Som standard är mellanskillnaden <b>växel</b>. Markera bara rutan om kunden uttryckligen säger att gruppen får behålla den som extra stöd.';
        }
      }else if(diff===0){
        keep.checked=false;keep.disabled=true;
        resultLabel.textContent="Resultat";
        change.textContent=money(0);
        resultSub.textContent="Exakt betalning – ingen växel.";
        explain.innerHTML='Kunden gav <b>'+esc(money(received))+'</b> och ordern kostar <b>'+esc(money(total))+'</b>. Allt stämmer.';
        support.innerHTML='Extra stöd blir tillgängligt först om kunden ger <b>mer</b> än orderns totalsumma.';
      }else{
        keep.checked=false;keep.disabled=true;
        resultLabel.textContent="Saknas";
        change.textContent=money(Math.abs(diff));
        resultSub.textContent="Kunden behöver betala mer.";
        explain.innerHTML='Kunden gav <b>'+esc(money(received))+'</b>. Ordern kostar <b>'+esc(money(total))+'</b> → det saknas <b>'+esc(money(Math.abs(diff)))+'</b>.';
        support.innerHTML='Beloppet måste minst täcka orderns totalsumma innan betalningen kan registreras.';
      }
    }
    inp.addEventListener("input",update);keep.addEventListener("change",update);update();
    var cb=document.getElementById("kp-po-report-cash");
    cb.addEventListener("click",function(){
      var received=parseMoneyInput(inp.value);
      var total=Math.round(Number(order.total_retail||0)*100)/100;
      if(!isFinite(received)||Math.round(received*100)<Math.round(total*100)){
        showPaymentError("Kontantbeloppet måste täcka orderns totalsumma.");
        return;
      }
      var err=document.getElementById("kp-po-payment-error");if(err)err.remove();
      reportPayment("cash",order,received,keep.checked,cb);
    });
  }
}
async function reportPayment(method,order,cash,keep,button){
  button.disabled=true;button.textContent="Registrerar…";
  try{
    if(order.preview_mode){
      var total=Number(order.total_retail||0),received=Number(cash||0),extra=0,change=0;
      if(method==="cash"){
        if(!isFinite(received)||received<total)throw new Error("Kontantbeloppet måste täcka orderns totalsumma.");
        if(keep&&received>total)extra=received-total;
        else change=received-total;
      }
      current.order.payment_reported_at=new Date().toISOString();
      showSuccess({
        display_number:order.display_number,
        total_retail:total,
        payment_method:method,
        extra_support:extra,
        change_due:change,
        preview_mode:true
      });
      return;
    }
    var out=await rpc("report_personal_order_payment_v1",{p_order_id:order.order_id,p_method:method,p_cash_received:cash,p_keep_change:!!keep});
    current.order.payment_reported_at=new Date().toISOString();
    showSuccess(out);
  }catch(e){showPaymentError(e.message||"Kunde inte registrera betalningen.");button.disabled=false;button.textContent=method==="swish"?"Kunden har swishat":"Registrera kontant betalning";}
}
function showSuccess(out){
  var method=out.payment_method==="cash"?"Kontant":"Swish";
  overlay(head("Klart","Order "+String(out.display_number||"")+" är registrerad.")+
    '<div class="kp-po-body"><div class="kp-po-success"><div class="kp-po-success-icon">✓</div><h3>Personlig order registrerad</h3><p class="kp-po-note mt-2">Betalningen är registrerad av säljaren. För Swish betyder det inte att Kampansera har verifierat banktransaktionen.</p>'+
      (out.preview_mode?'<div class="kp-po-order-saved mt-2"><b>Test klar.</b> Inga order- eller betalningsuppgifter sparades eftersom kampanjen inte är öppen för riktig försäljning.</div>':'')+
      '<div class="kp-po-breakdown"><div><span>Produkter</span><b>'+esc(money(out.total_retail))+'</b></div>'+
      (Number(out.extra_support||0)>0?'<div><span>Extra stöd till gruppen</span><b>'+esc(money(out.extra_support))+'</b></div>':'')+
      (Number(out.change_due||0)>0?'<div><span>Växel tillbaka</span><b>'+esc(money(out.change_due))+'</b></div>':'')+
      '<div><span>Betalning</span><b>'+esc(method)+'</b></div></div>'+
      '<div class="kp-po-actions mt-3"><button type="button" class="btn btn-primary" id="kp-po-done">Klart</button></div>'+
    '</div></div>');
  var closeBtn=document.getElementById("kp-po-close");if(closeBtn)closeBtn.onclick=finish;
  var done=document.getElementById("kp-po-done");if(done)done.addEventListener("click",finish);
}
function finish(){
  close();
  try{window.dispatchEvent(new Event("hashchange"));}catch(e){}
  setTimeout(mountUnpaidPanel,700);
}
async function startNew(){
  try{
    var portal=await loadPortal();
    if(!portal||!portal.has_group||!portal.campaign){alert("Du behöver en aktiv grupp och kampanj.");return;}
    var products=activeProducts(portal);
    if(!products.length){alert("Kampanjen har inga aktiva produkter.");return;}
    var qty={};products.forEach(function(p){qty[String(p.id)]=0;});
    overlay(orderStepHtml(portal,qty));
    bindOrderStep(portal,qty);
  }catch(e){alert(e.message||"Kunde inte öppna personlig order.");}
}
async function resumePayment(order){
  current={portal:null,order:order};
  showPayment(order);
}
async function mountUnpaidPanel(){
  if(route()!=="#/orders"||panelBusy)return;
  var content=document.querySelector(".content");if(!content)return;
  var old=document.getElementById("kp-personal-unpaid");if(old)return;
  panelBusy=true;
  try{
    var list=await rpc("get_my_personal_orders_v1",{});
    if(route()!=="#/orders")return;
    var unpaid=(Array.isArray(list)?list:[]).filter(function(o){return !o.payment_reported_at&&String(o.status)!=="cancelled";}).slice(0,3);
    if(!unpaid.length)return;
    var rows=unpaid.map(function(o){
      return '<div class="kp-unpaid-row"><div><b>'+esc(o.display_number||"Personlig order")+' · '+esc(o.customer_name||"Kund")+'</b><span>'+esc(money(o.total_retail))+' · väntar på betalningsregistrering</span></div><button type="button" class="btn btn-sm btn-ghost" data-kp-resume="'+esc(o.order_id)+'">Registrera betalning</button></div>';
    }).join("");
    var box=document.createElement("div");box.id="kp-personal-unpaid";box.className="kp-personal-unpaid";
    box.innerHTML='<h3>Personliga order som väntar på betalning</h3><p>Om du stängde betalningssteget tidigare kan du fortsätta här.</p>'+rows;
    var anchor=content.querySelector(".page-head");
    if(anchor)anchor.insertAdjacentElement("afterend",box);else content.prepend(box);
    box.querySelectorAll("[data-kp-resume]").forEach(function(b){
      b.addEventListener("click",function(){
        var id=b.dataset.kpResume;
        var o=unpaid.find(function(x){return String(x.order_id)===String(id);});
        if(o)resumePayment(o);
      });
    });
  }catch(e){}finally{panelBusy=false;}
}

document.addEventListener("click",function(e){
  var b=e.target.closest&&e.target.closest("#add-personal-order");
  if(!b)return;
  e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
  startNew();
},true);

window.addEventListener("hashchange",function(){setTimeout(mountUnpaidPanel,450);});
var app=document.getElementById("app");
if(app&&window.MutationObserver)new MutationObserver(function(){if(route()==="#/orders")setTimeout(mountUnpaidPanel,180);}).observe(app,{childList:true,subtree:true});
setTimeout(mountUnpaidPanel,700);
})();